import { For } from 'solid-js';
import SolariChar from './SolariChar';

interface SolariRowProps {
  position: number;
  teamName: string;
  time: string;
  timeDiffSeconds: number;
  animationDelay?: number;
  isTop3?: boolean;
}

function padRight(str: string, len: number): string {
  return str.substring(0, len).padEnd(len, ' ');
}

function padLeft(str: string, len: number): string {
  return str.substring(0, len).padStart(len, ' ');
}

function formatTimeDiff(seconds: number): string {
  if (seconds <= 0) return '';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (mins >= 60) {
    const hrs = Math.floor(mins / 60);
    const remainMins = mins % 60;
    return `+${hrs}:${String(remainMins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  return `+${mins}:${String(secs).padStart(2, '0')}`;
}

export default function SolariRow(props: SolariRowProps) {
  const posStr = () => padLeft(String(props.position), 2);
  const nameStr = () => padRight(props.teamName.toUpperCase(), 20);
  const timeStr = () => padRight(props.time, 8);
  const diffStr = () => {
    const diff = formatTimeDiff(props.timeDiffSeconds);
    return padRight(diff, 8);
  };

  const baseDelay = () => props.animationDelay || 0;

  return (
    <div class="solari-row" data-position={props.position}>
      {/* Position */}
      <div class="solari-field solari-pos">
        <For each={posStr().split('')}>
          {(char, i) => (
            <SolariChar char={char} delay={baseDelay() + i() * 30} />
          )}
        </For>
      </div>

      {/* Team name */}
      <div class="solari-field solari-name">
        <For each={nameStr().split('')}>
          {(char, i) => (
            <SolariChar char={char} delay={baseDelay() + (i() + 3) * 20} />
          )}
        </For>
      </div>

      {/* Time */}
      <div class="solari-field solari-time">
        <For each={timeStr().split('')}>
          {(char, i) => (
            <SolariChar char={char} delay={baseDelay() + (i() + 23) * 20} />
          )}
        </For>
      </div>

      {/* Time difference to leader */}
      <div class="solari-field solari-diff">
        <For each={diffStr().split('')}>
          {(char, i) => (
            <SolariChar char={char} delay={baseDelay() + (i() + 31) * 20} />
          )}
        </For>
      </div>
    </div>
  );
}
